import { Power0, Power3 } from 'gsap'
import AnimatedComponent from './AnimatedComponent'

class ProductEntryHero extends AnimatedComponent {
  buildTimelineIn () {
    const $el = this.$el
    this.timelineIn
      .fromTo(
        $el.find('.bg'),
        0.8,
        { scale: 1.2 },
        { scale: 1, ease: Power3.easeOut },
        0
      )
      .fromTo(
        $el.find('.bg'),
        0.4,
        { opacity: 0 },
        { opacity: 1, ease: Power0.easeNone },
        0
      )
  }
}

export default ProductEntryHero



// WEBPACK FOOTER //
// ./scripts/components/ProductEntryHero.js